/*********************************
 * String extension methods ******
**********************************/
//--- IMPLEMENTATION ---\\
(() => {
    if (!String.prototype.parseDigits) {
        function _parseDigits(stringInstance) {
            if (typeof stringInstance === "undefined" || stringInstance === null) {
                stringInstance = this;
            }
            const digitsArray = [];
            for (let i = 0; i < stringInstance.length; i++) {
                const numberChar = parseInt(stringInstance[i], 10);
                if (isNaN(numberChar)) {
                    continue;
                }
                digitsArray.push(numberChar.toString());
            }
            return digitsArray.length > 0 ? digitsArray.join('') : '';
        }
        String.prototype.parseDigits = _parseDigits;
    }
    if (!String.prototype.parseLettersAndDigits) {
        function _parseLettersAndDigits(stringInstance) {
            if (typeof stringInstance === "undefined" || stringInstance === null) {
                stringInstance = this;
            }
            const resultArray = [];
            for (let i = 0; i < stringInstance.length; i++) {
                const _char = /^[a-z0-9]+$/i.test(stringInstance[i]) ? stringInstance[i] : '';
                resultArray.push(_char.toString());
            }
            return resultArray.length > 0 ? resultArray.join('') : '';
        }
        String.prototype.parseLettersAndDigits = _parseLettersAndDigits;
    }
    if (!String.prototype.toTitleCase) {
        function _toTitleCase(stringInstance) {
            if (typeof stringInstance === "undefined" || stringInstance === null) {
                stringInstance = this;
            }
            return stringInstance.replace(/([^\W_]+[^\s-]*) */g, txt => (txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()));
        }
        String.prototype.toTitleCase = _toTitleCase;
    }
    if (!String.prototype.replaceSpacesWithDashes) {
        function _replaceSpacesWithDashes(stringInstance) {
            if (typeof stringInstance === 'undefined' || stringInstance === null) {
                stringInstance = this;
            }
            const result = stringInstance.split(' ').join('-');
            return result;
        }
        String.prototype.replaceSpacesWithDashes = _replaceSpacesWithDashes;
    }
    if (!String.prototype.replaceDashesWithSpaces) {
        function _replaceDashesWithSpaces(stringInstance) {
            if (typeof stringInstance === "undefined" || stringInstance === null) {
                stringInstance = this;
            }
            const result = stringInstance.split('-').join(' ');
            return result;
        }
        String.prototype.replaceDashesWithSpaces = _replaceDashesWithSpaces;
    }
    if (!String.prototype.removeDashesAndSpaces) {
        function _removeDashesAndSpaces(stringInstance) {
            var _a, _b;
            if (typeof stringInstance === "undefined" || stringInstance === null) {
                stringInstance = this;
            }
            const splitDashes = (_a = stringInstance === null || stringInstance === void 0 ? void 0 : stringInstance.split('-').join('')) !== null && _a !== void 0 ? _a : '';
            const splitSpaces = (_b = splitDashes === null || splitDashes === void 0 ? void 0 : splitDashes.split(' ').join('')) !== null && _b !== void 0 ? _b : '';
            return splitSpaces;
        }
        String.prototype.removeDashesAndSpaces = _removeDashesAndSpaces;
    }
})();
